type Props = { size?: number; className?: string };

export function Logo({ size = 80, className }: Props) {
  return (
    <div
      className={className}
      style={{ width: size, height: size }}
      aria-label="Khu Vui Chơi Nhà Thỏ"
    >
      <img
        src="/logo.png"
        alt="Nhà Thỏ"
        className="h-full w-full rounded-3xl object-cover shadow-2xl"
      />
    </div>
  );
}
